import * as actions from './actions'
import * as getters from './getters'
import * as types from './types'

const state = {
  existActivity: 0, // 是否有硬件参与押金活动
  authType: 1 // 商户实名认证类型
}

const mutations = {
  // [types.SET_ACCESS_TOKEN] (state, data) {
  //   state.accessToken = data
  // },
  [types.SET_EXIST_ACTIVITY] (state, data) {
    state.existActivity = data.existActivity
    state.authType = data.authType
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
